import { env, Native } from '@hb/NBridge/lib/h5';
import Big from 'big.js';
import map from '@/utils/maps/gaodeMap';
import { ParamsUtil } from './params';
/**
 * set document title when router change
 * @param {String} title title name
 */
export function setTitle(title) {
  document.title = title;
  // const iframe = document.createElement('iframe');
  // iframe.style.visibility = 'hidden';
  // const iframeCallback = () => {
  //   setTimeout(() => {
  //     iframe.removeEventListener('load', iframeCallback);
  //     document.body.removeChild(iframe);
  //   }, 0);
  // };
  // iframe.addEventListener('load', iframeCallback);
  // document.body.appendChild(iframe);
}

/**
 * cache return for function, ensure that the function is executed only once
 * @param {Function} func
 */

export function onceWrapper(func) {
  let isExecuted = false;
  let promiseObj = null;

  return (...arg) => {
    if (isExecuted) return promiseObj;
    isExecuted = true;
    promiseObj = func(...arg);
    return promiseObj;
  };
}

/**
 * 时间戳格式化.
 * @param  {number} time 时间戳 .
 * @param  {string} formatStr 格式 .
 * @param  {boolean} ms 时间戳是否是秒为单位, 10位true, 13位false .
 * @return {string} 格式化后的字符串.
 */
export function format(time, formatStr, ms) {
  const t = new Date(ms ? time * 1000 : time);
  const tf = function addZero(i) {
    return (i < 10 ? '0' : '') + i;
  };
  return formatStr.replace(/yyyy|MM|dd|HH|mm|ss/g, (a) => {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear());
      case 'MM':
        return tf(t.getMonth() + 1);
      case 'mm':
        return tf(t.getMinutes());
      case 'dd':
        return tf(t.getDate());
      case 'HH':
        return tf(t.getHours());
      case 'ss':
        return tf(t.getSeconds());
      default:
        return '';
    }
  });
}

export const isH5 = () => {
  const {
    isAliMP,
    isAliMPMonitor,
    isEasyBikeApp,
    isAlipayBrowser,
    isWechatMini,
  } = env;
  if (
    !isAliMP
    && !isAliMPMonitor
    && !isEasyBikeApp
    && !isAlipayBrowser
    && !isWechatMini
  ) {
    return true;
  }
  return false;
};

let cityPromise = null;
export function getCityInfo(force = false) {
  const isOk = () => window.$$location && window.$$location.cityCode;
  if (!force && isOk() && cityPromise) {
    return cityPromise;
  }
  /**
   * 微信环境和浏览器环境定位能力由高德能力切换到浏览器定位能力
   */
  const locationMethod = (env.isWeixin || isH5())
    ? map.getCityInfo()
    : Native.getCityInfo();

  cityPromise = locationMethod
    .then(({
      adCode, cityCode, longitude, latitude, requestLocation, locateFailMsg,
    }) => {
      if (locateFailMsg) {
        window.$$location = null;
        return {};
      }
      const info = {
        adCode,
        cityCode,
        longitude,
        latitude,
        ...(requestLocation || {}),
      };
      window.$$location = info;
      return info;
    })
    .catch(() => ({}));
  return cityPromise;
}

let userPromise = null;

export function getTokenAndKey({ force = false, needLogin = true } = {}) {
  const isOk = () => window.$$user && window.$$user.token;
  if (!force && isOk() && userPromise) {
    return userPromise;
  }
  const shouldLogin = env && (env.isAliMP || env.isAliMPMonitor) ? false : needLogin;
  // const params = {
  //   needLogin: (env.isAliMP || env.isAliMPMonitor) ? false : needLogin,
  // };
  // // 安卓环境下classMethod由Third替换business/user，解决外部跳转H5页面关闭情况
  // if (env.isAndroid) {
  //   params.classMethod = 'business/user';
  //   params.isFromTokenInValid = false;
  // }

  // eslint-disable-next-line no-console
  userPromise = Native.getTokenAndKey({ needLogin: shouldLogin, classMethod: 'User' })
    // userPromise = Native.getTokenAndKey(params)
    .then((info) => {
      const { userGuid } = ParamsUtil.getParams();
      const { guid } = info || {};
      const id = guid || userGuid;
      window.$$user = { ...info, guid: id, userGuid: id };
      return info;
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e);
      return {};
    });
  return userPromise;
}

export function getTokenAndLocation({ force = false, needLogin = true } = {}) {
  return Promise.all([
    getTokenAndKey({ force, needLogin }),
    getCityInfo(),
  ]).then(([user, city]) => ({ ...user, ...city }));
}

export function debounce(fn, delay = 100, immediate = false) {
  let timer = null;
  return function foo(...args) {
    const context = this;
    const callNow = immediate && !timer;

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      timer = null;
      if (!immediate) {
        fn.apply(context, args);
      }
    }, delay);

    if (callNow) {
      fn.apply(context, args);
    }
  };
}

export const startApp = (url) => Native.callNative({
  method: 'startApp',
  classMap: 'Native',
  params: {
    appId: '20000067',
    param: {
      url,
    },
  },
});

export const isPreRender = () => !!window.__PRERENDER_INJECTED;

export const isUndefinedOrNull = (v) => v === undefined || v === null;

export const ensureUndefinedOrNull = (v, fallback) => (isUndefinedOrNull(v) ? fallback : v);

export function sub(a, b) {
  return new Big(a).minus(b).toString();
}

export function add(a, b) {
  return new Big(a).add(b).toString();
}

export function tryCatch(thunk, fallback = null) {
  try {
    return thunk();
  } catch (error) {
    return fallback;
  }
}

export function getTWCardPlatform() {
  if (env.isWechatMini) {
    return '2';
  }
  if (isH5()) {
    return '3';
  }
  if (env.isAliMP || env.isAliMPMonitor) {
    return '1';
  }
  if (env.isEasyBikeApp) {
    if (env.isAndroid) {
      return '0';
    }
    if (env.isIOS) {
      return '10';
    }
  }
  return '3';
}

export function getSource() {
  const query = ParamsUtil.getParams(window.location.href);
  if (!query) {
    return '';
  }
  const { source, adsource, adSource } = query;
  return adsource || adSource || source;
}

export function smoothScroll(top, left = 0, el = window) {
  if (!top && !left) {
    return;
  }
  try {
    el.scrollTo({ top, left, behavior: 'smooth' });
  } catch (error) {
    el.scrollTo(left, top);
  }
}

// 左右滚动，让被点击元素到父元素中间
export function scrollToMid(child, father) {
  if (!child || !father) {
    return;
  }
  const sceenWidth = document.documentElement.clientWidth;
  const { width: childWidth, left: childLeft } = child.getBoundingClientRect();
  smoothScroll(
    0,
    childLeft + childWidth / 2 - sceenWidth / 2 + father.scrollLeft,
    father,
  );
}

// 滚动到最左边,让子元素对齐父元素左边缘
export function scrollToLeft(child, father, offset = 0) {
  if (!child || !father) {
    return;
  }
  const { left: childLeft } = child.getBoundingClientRect();
  const { left: fatherLeft } = father.getBoundingClientRect();
  smoothScroll(
    0,
    childLeft - fatherLeft + father.scrollLeft + offset,
    father,
  );
}

// 一般不要用
export function commonGoLink(link, option = {}) {
  const options = {
    fallbackWithGoOperationUrl: false, // 在小程序端是否用goOperationUrl进行跳转
    isRuleLink: false, // 是否是规则链接
    ...(option || {}),
  };
  if (env.isEasyBikeApp) {
    if (options.isRuleLink) {
      Native.openThirdWeb({ url: link }).catch(() => null);
    } else {
      Native.callNative({
        method: env.isIOS ? 'platformOpenUrl' : 'openUrl',
        params: {
          jumpUrl:
            link.indexOf('http') === 0
              ? `hellobike://hellobike.com/openWeb?webUrl=${encodeURIComponent(link)}`
              : link,
        },
        classMap: 'business/train',
      }).catch(() => null);
    }
  } else if (
    (env.isAliMP || env.isAliMPMonitor)
    && options.fallbackWithGoOperationUrl
  ) {
    Native.callNative({
      method: 'goOperationUrlV2',
      params: link,
    }).catch();
  } else {
    window.location.href = link;
  }
}

/**
 * 根据指定的调用结果缓存时间进行缓存
 * @param {*} callback - 具体执行函数
 * @param {*} cacheTime - 每次调用的结果缓存时间
 * @param {function} [onHitCache] - 命中缓存后的回调
 */
export const cacheByTime = (callback, cacheTime = 200, onHitCache) => {
  let lastTime = 0;
  let promise = null;
  return (...args) => {
    const now = Date.now();
    if (!promise || now - lastTime > cacheTime) {
      lastTime = now;
      promise = callback(...args);
    } else {
      try {
        if (onHitCache) {
          onHitCache(args, promise);
        }
        // eslint-disable-next-line no-empty
      } catch (e) { }
    }
    return promise;
  };
};


export function genRandomNum(len) {
  const ans = [];
  for (let i = 0; i < len; i += 1) {
    ans.push(Math.floor(Math.random() * 10));
  }
  return ans;
}


export function copyToClipboard(text) {
  const { clipboard } = navigator || {};

  if (clipboard === undefined) {
    return Promise.reject();
  }
  return clipboard.writeText(text);
}

export const getNoScroll = (noSrcoll) => {
  const [htmlTag] = document.getElementsByTagName('html');
  let bodyTag = null;
  if (env.isAndroid) {
    [bodyTag] = document.getElementsByTagName('body');
  }
  if (noSrcoll) {
    htmlTag.classList.add('no-scroll');
    if (env.isAndroid) {
      bodyTag.classList.add('no-scroll');
    }
  } else {
    htmlTag.classList.remove('no-scroll');
    if (env.isAndroid) {
      bodyTag.classList.remove('no-scroll');
    }
  }
};
export const safeGet = (obj, path, defaultValue) => {
  const pathArray = path.split(/[.[\]]+/).filter(Boolean);
  let result = obj;

  for (let i = 0; i < pathArray.length; i += 1) {
    const isInteger = /^\d+$/.test(pathArray[i]);
    const key = isInteger ? parseInt(pathArray[i], 10) : pathArray[i];

    if (result == null || !(key in result)) {
      return defaultValue;
    }

    result = result[key];
  }

  return result;
};

/**
 * 降级方案：使用 document.execCommand 复制文本
 * @param {string} text - 要复制的文本
 * @returns {Promise<boolean>} - 返回复制是否成功
 */
function fallbackCopyTextToClipboard(text) {
  return new Promise((resolve) => {
    // 创建一个临时的 textarea 元素
    const textArea = document.createElement('textarea');
    textArea.value = text;
    // 设置样式，使其不可见但可选择
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.style.opacity = '0';
    textArea.style.zIndex = '-1';
    document.body.appendChild(textArea);
    try {
      // 选择文本
      textArea.focus();
      textArea.select();
      textArea.setSelectionRange(0, 99999); // 移动端兼容性
      // 执行复制命令
      const successful = document.execCommand('copy');
      // 清理
      document.body.removeChild(textArea);
      resolve(successful);
    } catch (error) {
      // 清理
      document.body.removeChild(textArea);
      resolve(false);
    }
  });
}

/**
 * 复制文本到剪贴板
 * 优先使用现代 Clipboard API，降级到 document.execCommand
 * @param {string} val - 要复制的文本内容
 * @returns {Promise<boolean>} - 返回复制是否成功
 */
export async function copyText(val) {
  // 参数验证
  if (!val || typeof val !== 'string') {
    // eslint-disable-next-line no-console
    console.warn('copyText: 无效的文本内容');
    return false;
  }

  try {
    // 优先使用现代 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(val);
      return true;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Clipboard API 失败，尝试降级方案:', error);
  }

  // 降级方案：使用 document.execCommand
  try {
    return await fallbackCopyTextToClipboard(val);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('复制文本失败:', error);
    return false;
  }
}
